import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Button,
  Stack,
  Divider,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  SectionText,
  useModal,
} from '@fortress-technology-solutions/fortress-component-library/Molecules_Portal';
import { Collapse } from '@fortress-technology-solutions/fortress-component-library/Transitions';
import ConditionsForStudentsModal from 'components/Molecules/ConditionsForStudentsModal';
import usePropertyInfoQuery from 'hooks/usePropertyInfoQuery';

const AffordaPropertyAndProgram = (props) => {
  const intl = useIntl();
  const modalProps = useModal(false);

  const { data: propertyInfo } = usePropertyInfoQuery();
  const getIncomeValue = React.useCallback(() => {
    if (!propertyInfo || !propertyInfo.applicationIncomeMultiplier) {
      return '';
    }
    const parenthesesValue = /\(([^)]+)\)/;
    const incomeValue =
      propertyInfo.applicationIncomeMultiplier.match(parenthesesValue);

    return incomeValue ? incomeValue[1] : '';
  }, [propertyInfo]);

  const incomeMultiplier = React.useMemo(() => {
    return getIncomeValue();
  }, [getIncomeValue]);

  const isValidIncomeMultiplier = React.useMemo(() => {
    return (
      incomeMultiplier?.length > 0 &&
      incomeMultiplier !== '0' &&
      incomeMultiplier !== '0.0' &&
      incomeMultiplier !== 'NA'
    );
  }, [incomeMultiplier]);

  return (
    <>
      <SectionText
        title={intl.formatMessage({ id: 'afforda.propertyProgram.title' })}
        description={intl.formatMessage({
          id: 'afforda.propertyProgram.description',
        })}
      />
      <Divider sx={{ marginY: 2 }} />
      <Stack
        component={'ul'}
        spacing={2}
        sx={{ paddingInlineStart: 0, paddingX: 4, textAlign: 'left' }}
      >
        <Typography component={'li'}>
          <FormattedMessage id={`afforda.propertyProgram.listItem1`} />
        </Typography>
        <Typography component={'li'}>
          <FormattedMessage id={`afforda.propertyProgram.listItem2`} />
        </Typography>
        <Collapse in={propertyInfo?.isTransUnionActive}>
          <Typography component={'li'}>
            <FormattedMessage id={`afforda.propertyProgram.listItem3`} />
          </Typography>
        </Collapse>
        {isValidIncomeMultiplier && (
          <Typography component={'li'}>
            <FormattedMessage
              id={`afforda.propertyProgram.listItem4`}
              values={{
                applicationIncomeMultiplier: incomeMultiplier,
              }}
            />
          </Typography>
        )}
        <Typography component={'li'}>
          <FormattedMessage id={`afforda.propertyProgram.listItem5`} />
        </Typography>
        <Typography component={'li'}>
          <FormattedMessage id={`afforda.propertyProgram.listItem6`} />
        </Typography>
      </Stack>

      <Button
        variant={'text'}
        mb={1}
        sx={{ textDecoration: 'underline', color: 'text.secondary' }}
        onClick={modalProps.openModal}
      >
        <FormattedMessage
          id={'afforda.propertyProgram.conditionsForStudents'}
        />
      </Button>
      <ConditionsForStudentsModal {...modalProps} />
    </>
  );
};

export default AffordaPropertyAndProgram;
